import { render, staticRenderFns } from "./AgentCard.vue?vue&type=template&id=e33fb24c&scoped=true&"
import script from "./agent-card.ts?vue&type=script&lang=ts&"
export * from "./agent-card.ts?vue&type=script&lang=ts&"
import style0 from "./agent-card.scss?vue&type=style&index=0&id=e33fb24c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e33fb24c",
  null
  
)

export default component.exports